const copy = {
  en: {
    app: {},
    ambassadors: {
      landing: {
        hero: {
          title: 'Lead the charge in our movement',
          subtitle:
            'At abillion, we’re empowering a global community of people to do what’s right for their bodies, the planet and all living things. As our Ambassador, you get rewarded every time a new member joins the abillion community thanks to your efforts.',
          button1: 'Join Now',
          button2: 'Log in',
          isAmbassador: 'Already an Ambassador?  ',
          goToDashboard: 'Go to dashboard',
          image:
            'https://res.cloudinary.com/abillionveg/image/upload/v1575019252/influencers_landing/abv_Founders_Landing_Page__Hero.png'
        },
        statistics: {
          downloads: {
            number: 'Over 1 million',
            label: 'downloads',
            hasPlus: false
          },
          donations: {
            number: 'US$ 2 million',
            label: 'donated',
            hasPlus: false
          },
          countries: {
            number: '160',
            label: 'countries',
            hasPlus: true
          },
          partners: {
            number: '60',
            label: 'non-profit partners',
            hasPlus: true
          }
        },
        benefits: {
          title: "The impact that you're creating as an ambassador",
          subtitle: "You're a voice for positive, social change.",
          text: "We're on a mission to inspire a billion people to go plant-based by 2030, and we're excited that you're joining us. By getting people to download the abillion app, choose something vegan and review it, you're making a difference, every single time.",
          reasons: {
            reason1: {
              image:
                'https://res.cloudinary.com/abillionveg/image/upload/v1575454561/influencers_landing/cow.png',
              title: "An Animal's Life Saved",
              text: 'Every review on abillion converts into donation credits which you can donate to our amazing',
              text2: ' non-profit partners.',
              text3:
                ' You can support charities whose work evolves around farm animal protection, nature conservation or food security. Every donation makes a difference.'
            },
            reason2: {
              image:
                'https://res.cloudinary.com/abillionveg/image/upload/v1574660005/influencers_landing/Sustainable_Planet.png',
              title: 'Get Businesses to Be More Sustainable',
              text: "Reviews and feedback on abillion get shared directly with business owners, influencing restaurants and brands worldwide to offer more plant-based, sustainable options. You’re creating a more sustainable world by showing others what's on your plate!"
            },
            reason3: {
              image:
                'https://res.cloudinary.com/abillionveg/image/upload/v1574660004/influencers_landing/People_working_together.png',
              title: 'Help People Eat Vegan',
              text: "abillion is run on member-generated content, so the more reviews posted on the app, the more options people see when they're looking for vegan food or products. Reviews make it easier for people to lead a plant-based lifestyle."
            },
            reason4: {
              image:
                'https://res.cloudinary.com/abillionveg/image/upload/v1574660003/influencers_landing/coin.png',
              title: 'Get Rewarded Every Single Time',
              text: 'Whenever your followers get on the app with your code and verify their email, you get paid.'
            }
          },
          borderImage:
            'https://res.cloudinary.com/abillionveg/image/upload/v1574669269/influencers_landing/wavey.png'
        },
        steps: {
          title: 'How it works',
          steps: {
            step1: {
              image:
                'https://res.cloudinary.com/abillionveg/image/upload/v1574660005/influencers_landing/step_1_user_sign_up.png',
              title: 'Step 1',
              text: "Sign up as an abillion Ambassador. You'll receive a confirmation email once you've been verified by us."
            },
            step2: {
              image:
                'https://res.cloudinary.com/abillionveg/image/upload/v1574660005/influencers_landing/step_2_link.png',
              title: 'Step 2',
              text: "Share your own unique referral code to your community! We know that when we come together, we're empowered to create meaningful change in the world, and we chose YOU to join us on our transformative mission."
            },
            step3: {
              image:
                'https://res.cloudinary.com/abillionveg/image/upload/v1574660005/influencers_landing/step_3_share.png',
              title: 'Step 3',
              text: 'Track your sign ups and their reviews in real-time on your personal dashboard and get paid. No fuss, just facts.'
            }
          }
        },
        preview: {
          title: 'Ambassador Dashboard',
          text: 'We make it easy for you to directly engage with your community. Track, analyze, and monitor in real-time the number of people you’re influencing through your link. Less time spent analyzing means more time for growing and engaging with a conscious community!',
          image:
            'https://res.cloudinary.com/abillionveg/image/upload/v1656567017/ambassadors/ambassador_dashboard_preview.webp'
        },
        CTA: {
          title: 'Have any questions?',
          faqButton: 'View FAQ',
          contactButton: 'Contact us'
        }
      }
    }
  }
}

export default copy
